import { defineMessages } from 'react-intl'

export default defineMessages({
  definePayload: {
    id: 'SpaceAppBuilderFeaturesPage.featureTrigger.definePayload',
    defaultMessage: 'Define Payload'
  },
  payloadInvalidJson: {
    id: 'SpaceAppBuilderFeaturesPage.featureTrigger.payloadInvalidJson',
    defaultMessage: 'Please enter valid JSON'
  },
  pleaseDefinePayload: {
    id: 'SpaceAppBuilderFeaturesPage.featureTrigger.pleaseDefinePayload',
    defaultMessage: 'Please define a request payload'
  },
  beautify: {
    id: 'SpaceAppBuilderFeaturesPage.featureTrigger.beautify',
    defaultMessage: 'Beautify Code'
  }
})
